import { connect } from 'react-redux';
import React from 'react';
import { renderKBSelect, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';
import { KBFormError,
KBButton } from
'components';
import { successState } from 'app/actions';
import { bindActionCreators } from 'redux';
import { INVOICE_CONFIRM } from 'app/constants';

var SpaceSettingInvoiceConfirm = class extends React.Component {constructor(props) {super(props);this.updateSpace = this.updateSpace.bind(this);}updateSpace(


  model) {
    const { updateCurrentSpace } = this.props;
    const submitModel = {
      ...model,
      invoice_need_confirm: model.invoice_need_confirm == 'true' ? true : false };
    updateCurrentSpace(
    {
      settings: JSON.stringify({
        invoice_settings: submitModel }) },


    {
      key: 'invoice_settings' });


  }render()

  {
    const {
      fields: { invoice_need_confirm },
      error,
      submitting,
      handleSubmit } =
    this.props;
    return (
      <form onSubmit={handleSubmit(this.updateSpace)}>
        <KBFormError err={this.props.error} />
        <div className="kb-form-container" style={{ padding: 0 }}>
          <KBFormError err={error} />
          <div className="kb-row">
            <Field name="invoice_need_confirm" component={renderKBSelect}
            className="kb-form-group kb-form-c39 kb-form-alone"

            title="账单确认核销"
            arrayData={INVOICE_CONFIRM} />

          </div>
          <div className="kb-row m-top">
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              保存
            </KBButton>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  const setting = props.setting || {};
  const invoiceSettings = setting.invoice_settings || {};
  let setting_value = invoiceSettings.invoice_need_confirm || 'false';
  return {
    initialValues: { invoice_need_confirm: setting_value } };

}

function mapDispatchToProps(dispatch) {
  return {
    successAction: bindActionCreators(successState, dispatch) };

}

const LEGACY_FORM_FIELDS = [
  "invoice_need_confirm"
];

const formConfig = {
  form: 'SpaceSettingInvoiceConfirm',
  touchOnBlur: false };


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('SpaceSettingInvoiceConfirm', LEGACY_FORM_FIELDS)(SpaceSettingInvoiceConfirm)));
